<div class="table-name-input">
  <blaze-select
    [showSelection]="true"
    [multiselect]="false"
    [filtered]="true"
    [allowNone]="false"
    [formControl]="form.controls.fieldId"
    [options]="(availableMappings$ | async) || []"
  />
</div>
<div class="table-field-input">
  <blaze-select
    [showSelection]="true"
    [multiselect]="false"
    [filtered]="true"
    [allowNone]="false"
    [formControl]="form.controls.columnId"
    [options]="(selectedMapping$ | async)?.columns || []"
  />
</div>

<div class="table-actions">
  @if (canRemove) {
    <button
      blazeIconButton
      blazeIconButtonSize="xl"
      class="action remove"
      (click)="remove.emit()"
      type="button"
    >
      <mat-icon svgIcon="icon_trash_24" />
    </button>
  }
</div>
